
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 16.5h11a2 2 0 012 2v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a2 2 0 012-2v0zm-2 3h2.5m10 0H19m-13-3l.391-3.124a1 1 0 01.992-.876h8.234a1 1 0 01.992.876L17 16.5M3.5 15L6 16.5M19.5 15L17 16.5m-10 5v1a1 1 0 11-2 0v-1m13 0v1a1 1 0 01-2 0v-1M8.716 5.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.2 6l6.29.007 1.414-1.414-1.411-1.414L12.2 3a4 4 0 100 3v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    